import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import styles from './SortIcon.module.css';

const SORT_ICONS = {
  none: icon({ name: 'sort', style: 'solid' }),
  asc: icon({ name: 'sort-up', style: 'solid' }),
  desc: icon({ name: 'sort-down', style: 'solid' }),
};

/**
 * Glyphe de tri d'un en-tête (suivi et tableaux du site). Une boîte de largeur
 * fixe : les trois glyphes n'ont pas la même largeur, et l'en-tête sautait à
 * chaque clic. Sans `color`, il prend celle de l'en-tête.
 */
export default function SortIcon({ dir = null, color, className = '' }) {
  return (
    <span className={`${styles.sortIcon} ${className}`.trim()} data-active={dir ? true : undefined}>
      <FontAwesomeIcon icon={SORT_ICONS[dir || 'none']} style={{ fontSize: 10, color }} />
    </span>
  );
}
